
import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("ChoferZE");
const crud = rpcCrudService<models.ChoferZE, models.ChoferZEDto>(controller);

export interface DatosRepetidoChoferZE {
    idChoferZE: number | null;
}

export const ChoferZE = cacheResource({
    ...crud,
    RepetidoIdentificacion: async (valor: string, campo: CampoRepetidoIdentificacion, datos: DatosRepetidoChoferZE): Promise<boolean> => await controller("Repetido" + campo, { ...datos, valor }),

    Nada: async (): Promise<void> => { },

    /**
     * Regresa el id del vehículo de zona extendida asignado a un chofer
     * @param idChoferZE 
     */
    ObtenerVehiculoAsignado: async (idChoferZE: number): Promise<number | null> => await controller("ObtenerVehiculoAsignado", { idChoferZE }),

    QueryById: async (idUsuarioZE:number): Promise<models.ChoferZEDto[]> => await controller("QueryById",{ idUsuarioZE }),

}, {
        query: true,
        getMemo: true
    }, {
        add: true,
        delete: true,
        update: true,
        Nada: true,
    });
const test: ResourceIdentificacionRepetido<DatosRepetidoChoferZE> = ChoferZE;


// WEBPACK FOOTER //
// ./app/resources/items/choferze.tsx